const state = {
  type: null,
  group: null,
  // Promise resolving to the eventual drag group. Used by drag sources that
  // build their contents asynchronously (e.g. a whole Show fetched from the
  // API), so the drop handler can await the real items instead of keeping a
  // placeholder element.
  pendingGroup: null,
};

const actions = {
  setDragType(context, opts) {
    const type = typeof opts === 'string' ? opts : opts.type;
    const group = typeof opts === 'object' && opts.group;
    const pendingGroup = typeof opts === 'object' && opts.pendingGroup;

    context.commit('SET_DRAG_TYPE', type);
    context.commit('SET_DRAG_GROUP', group || null);
    context.commit('SET_DRAG_PENDING_GROUP', pendingGroup || null);
  },

  clearDragType(context) {
    context.commit('SET_DRAG_TYPE', null);
    context.commit('SET_DRAG_GROUP', null);
    context.commit('SET_DRAG_PENDING_GROUP', null);
  },
};

const mutations = {
  /* eslint-disable no-param-reassign, no-shadow */

  SET_DRAG_TYPE(state, type) {
    state.type = type;
  },

  SET_DRAG_GROUP(state, val) {
    state.group = val;
  },

  SET_DRAG_PENDING_GROUP(state, val) {
    state.pendingGroup = val;
  },
};

export default {
  state,
  actions,
  mutations,
};
